import { useCallback, useState } from 'react';

/**
 * Form values plus their validation errors. `setField` updates one value and
 * clears that field's error (and any form-level error) straight away, so a
 * message disappears as soon as the user fixes the field rather than on Save.
 * Pass extra keys to clear errors that depend on this field (e.g. a date range).
 */
export default function useFormState(initial) {
  const [form, setForm] = useState(initial);
  const [errors, setErrors] = useState({});

  const clearErrors = useCallback((...keys) => {
    setErrors((prev) => {
      if (!keys.some((k) => prev[k]) && !prev.form) return prev;
      const next = { ...prev };
      keys.forEach((k) => delete next[k]);
      delete next.form;
      return next;
    });
  }, []);

  const setField = useCallback(
    (key, value, ...alsoClear) => {
      setForm((f) => ({ ...f, [key]: value }));
      clearErrors(key, ...alsoClear);
    },
    [clearErrors]
  );

  return { form, setForm, errors, setErrors, setField, clearErrors };
}
